"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.onKeyDownEnter = void 0;
const components_1 = require("@veeam/components");
require("../../core");
const onKeyDownEnter = (callback) => (e) => {
    if (e.keyCode === components_1.KeyCode.Enter) {
        callback();
    }
};
exports.onKeyDownEnter = onKeyDownEnter;
//# sourceMappingURL=onKeyDownEnter.js.map